const QuestionText = ({props}) => {
    return (
    <div className = "question">
        <h3> {props} </h3>
    </div>
    );
}

export default QuestionText;